import axios from "axios";

const apiDatosPersonal = {	

	async readDatosPersonal() {           
		axios.defaults.headers.common['token'] = window.localStorage.getItem('tokenUser');
		const response = await axios.get("/api/datospersonal");  
		return response.data;        
	},
	async getDatosPersonal(noPlaza) {           
		axios.defaults.headers.common['token'] = window.localStorage.getItem('tokenUser');
		const response = await axios.get("/api/datospersonal/"+noPlaza);  
		return response.data;        
	},
	async updateDatosPersonal(noPlaza, requestData) {
		axios.defaults.headers.common['token'] = window.localStorage.getItem('tokenUser');
		const response = await axios.put("/api/datospersonal/"+noPlaza, requestData);
		return response.data;
	}
};

export default apiDatosPersonal;
